import { EventService } from "./services/Event";
import { DialogService } from "./interaction/DialogService";

// Event
export function eventServiceFactory(i: any) {
    return i.get("EventService");
}

export const eventServiceProvider = {
    provide: EventService,
    useFactory: eventServiceFactory,
    deps: ["$injector"],
};

// location
export function locationFactory(i: any) {
    return i.get("$location");
}

export const locationProvider = {
    provide: "$location",
    useFactory: locationFactory,
    deps: ["$injector"],
};

// Dialog
export function dialogServiceFactory(i: any) {
    return i.get("DialogService");
}

export const dialogServiceProvider = {
    provide: DialogService,
    useFactory: dialogServiceFactory,
    deps: ["$injector"],
};

export const dialogStringServiceProvider = {
    provide: "DialogService",
    useFactory: dialogServiceFactory,
    deps: ["$injector"],
};
